import { cartPageContainerStyles } from "@insite/content-library/Widgets/Cart/CartPageContainer";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import { css } from "styled-components";

cartPageContainerStyles.cartLinesContainer = {
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        border: 0 solid transparent;
                        border-width: 0 1.5rem 0 0;
                    `,
                    null,
                    css`
                        grid-column-end: 6;
                        grid-column-start: 1;
                        -ms-grid-column: 1;
                        grid-row-start: 2;
                        -ms-grid-row: 2;
                        grid-row-end: 6;
                        -ms-grid-row-span: 6;
                    `,
                    css`
                        grid-column-start: 1;
                        -ms-grid-column: 1;
                        grid-row-start: 3;
                        -ms-grid-row: 2;
                        grid-row-end: 6;
                        -ms-grid-row-span: 6;
                        padding-right: 40px;
                        grid-column-end: 1;
                    `,
                ],
                "min",
            )}
    `,
};

cartPageContainerStyles.cartTotalContainer = {
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        border: 0 solid transparent;
                        border-width: 0 1.5rem 1.5rem 0;
                    `,
                    null,
                    css`
                        grid-column-start: 1;
                        grid-column-end: 6;
                        -ms-grid-column: 2;
                        grid-row-start: 6;
                        -ms-grid-row: 3;
                    `,
                    css`
                        grid-column-start: 2;
                        -ms-grid-column: 2;
                        grid-row-start: 3;
                        -ms-grid-row: 3;
                    `,
                ],
                "min",
            )}
    `,
};

cartPageContainerStyles.productCarouselContainer = {
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        border: 0 solid transparent;
                        border-width: 0 1.5rem 1.5rem 0;
                    `,
                    null,
                    css`
                        grid-column-start: 1;
                        grid-column-end: 6;
                        -ms-grid-column: 2;
                        grid-row-start: 12;
                        -ms-grid-row: 3;
                    `,
                    css`
                        grid-column-start: 2;
                        -ms-grid-column: 2;
                        grid-row-start: 6;
                        -ms-grid-row: 3;
                    `,
                ],
                "min",
            )}
    `,
};
cartPageContainerStyles.container = {
    css: css`
        /* stylelint-disable value-no-vendor-prefix */
        display: -ms-grid;
        display: grid;
        padding: 1.5rem 0 0 1.5rem;
        margin: -1.5rem;
        overflow: hidden;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        grid-template-columns: minmax(0, 1fr);
                        -ms-grid-columns: minmax(0, 1fr);
                    `,
                    null,
                    css`
                        grid-template-columns: repeat(2, minmax(0, 1fr));
                        -ms-grid-columns: minmax(0, 1fr) minmax(0, 1fr);
                        grid-template-rows: repeat(5, auto);
                        -ms-grid-rows: auto auto auto auto auto;
                    `,
                    css`
                        grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);
                        -ms-grid-columns: minmax(0, 2fr) minmax(0, 1fr);
                    `,
                ],
                "min",
            )}
        h1[data-test-selector="PageTitle"] {
            font-size: 56px;
            line-height: 64px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-size: 32px;
                        line-height: 50px;
                        font-weight: ${TYPOGRAPHY.weight.bold};
                    `,
                    css`
                        font-size: 32px;
                        line-height: 50px;
                        font-weight: ${TYPOGRAPHY.weight.bold};
                    `,
                    null,
                    null,
                    null,
                ])}
        }
    `,
};
